import { render, staticRenderFns } from "./CollegeOrganContactPersonView.vue?vue&type=template&id=50b7b49d&scoped=true"
import script from "./CollegeOrganContactPersonView.vue?vue&type=script&lang=js"
export * from "./CollegeOrganContactPersonView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b7b49d",
  null
  
)

export default component.exports